/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'

const $nsid = 'com.atproto.server.createAccount'

export { $nsid }

export const $params = /*#__PURE__*/ l.params()

export type $Params = l.InferOutput<typeof $params>

export const $input = /*#__PURE__*/ l.jsonPayload({
  email: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
  handle: /*#__PURE__*/ l.string({ format: 'handle' }),
  did: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string({ format: 'did' })),
  inviteCode: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
  verificationCode: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
  verificationPhone: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
  password: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
  recoveryKey: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
  plcOp: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.lexMap()),
})

export type $Input<B = l.BinaryData> = l.InferPayload<typeof $input, B>
export type $InputBody<B = l.BinaryData> = l.InferPayloadBody<typeof $input, B>

export const $output = /*#__PURE__*/ l.jsonPayload({
  accessJwt: /*#__PURE__*/ l.string(),
  refreshJwt: /*#__PURE__*/ l.string(),
  handle: /*#__PURE__*/ l.string({ format: 'handle' }),
  did: /*#__PURE__*/ l.string({ format: 'did' }),
  didDoc: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.lexMap()),
})

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<
  typeof $output,
  B
>

/** Create an account. Implemented by PDS. */
const main = /*#__PURE__*/ l.procedure($nsid, $params, $input, $output, [
  'InvalidHandle',
  'InvalidPassword',
  'InvalidInviteCode',
  'HandleNotAvailable',
  'UnsupportedDomain',
  'UnresolvableDid',
  'IncompatibleDidDoc',
])

export { main }

export const $lxm = $nsid
